module.exports = __webpack_public_path__ + "img/Group 233.99031287.png";